import React from "react";
import logoSchoofin from "../assets/images/logo/Logo-Schofin-14.png";

const Loading = () => {
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-gradient-to-br from-teal-600 via-teal-500 to-emerald-400 dark:bg-none dark:bg-gray-950 relative overflow-hidden">
      {/* Decorative circles — light mode only */}
      <div className="absolute -top-20 -left-20 w-80 h-80 bg-white opacity-5 rounded-full dark:hidden" />
      <div className="absolute -bottom-24 -right-16 w-96 h-96 bg-white opacity-5 rounded-full dark:hidden" />
      <div className="absolute top-1/3 right-12 w-32 h-32 bg-white opacity-5 rounded-full dark:hidden" />
      <div className="absolute bottom-1/3 left-16 w-20 h-20 bg-white opacity-[0.07] rounded-full dark:hidden" />

      <div className="relative z-10 flex flex-col items-center gap-6">
        {/* Logo */}
        <img
          src={logoSchoofin}
          alt="Schoofin"
          className="w-24 drop-shadow-lg dark:opacity-90"
        />

        {/* Spinner */}
        <svg
          className="animate-spin w-8 h-8 text-white dark:text-teal-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            className="opacity-90"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>

        {/* Text */}
        <div className="text-center">
          <p className="text-sm font-semibold text-white dark:text-slate-200">
            SCHOOFIN.ID
          </p>
          <p className="text-xs text-teal-100 dark:text-slate-500 mt-1">
            Sedang memuat...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
